const TIMEOUT = 60000;

const IS_MOCK_API = process.env.REACT_APP_IS_MOCK === 'true';

const LANGUAGE_EN_US = 'en-us';
const LANGUAGE_ZH_HK = 'zh-hk';

export const BS_API_URL = process.env.REACT_APP_BS_API_URL;

export const DUTY_API_URL = process.env.REACT_APP_DUTY_API_URL;

export const EHAND_API_URL = process.env.REACT_APP_EHAND_API_URL;

export const EQUIPMENT_API_URL = process.env.REACT_APP_EQUIPMENT_API_URL;

export const SYS_API_URL = process.env.REACT_APP_SYS_API_URL;

export const TV_API_URL = process.env.REACT_APP_TV_API_URL;

export const EADMISSION_API_URL = process.env.REACT_APP_EADMISSION_API_URL;

export const PATIENT_SURVEY_API_URL = process.env.REACT_APP_PATIENT_SURVEY_API_URL;

export { TIMEOUT, IS_MOCK_API, LANGUAGE_EN_US, LANGUAGE_ZH_HK };
